/*
Renders a font awesome icon that matches the document type
*/

import React, { DetailedHTMLProps, HTMLAttributes } from "react";
import Tippy from "@tippyjs/react";
import classNames from "classnames";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { Placement } from "@popperjs/core";
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome";

export function getDocumentTypeFromMime(mime: string) : number {
    return -1;
};

export type DocumentTypeIconProps = FontAwesomeIconProps & {
    documentType: number,
    description?: string | null | undefined,
    outerElement?: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
    tooltipPlacement?: Placement
};

export const DocumentTypeIcon = ({ 
    className = "fs-4", 
    description, 
    icon, 
    outerElement,
    tooltipPlacement = 'auto', 
    documentType, 
    ...props 
} : Readonly<DocumentTypeIconProps>) => {
    const calculateIcon = () : IconProp => {
        switch(documentType) {
            case -1:
                return ["fas", "file-upload"]
            case 0: // Word
                return ["fas", "file-word"];
            case 1: // Excel
                return ["fas", "file-excel"];
            case 2: // Outlook
            case 3: // Email
                return ["fas", "file-code"];
            case 4: // PDF
                return ["fas", "file-pdf"];
            case 5: // Text
                return ["fas", "file-lines"];
            case 6: // Image
                return ["fas", "file-image"];
            case 7: // Video
                return ["fas", "file-video"];
            default:
                return ["fas", "file"];
        };
    };

    const iconClassName = classNames(className, {
        'text-word': documentType === 0,
        'text-excel': documentType === 1,
        'text-code': documentType === 2 || documentType === 3,
        'text-pdf': documentType === 4,
        'text-lines': documentType === 5,
        'text-image': documentType === 6,
        'text-video': documentType === 7,
        'text-file': typeof(documentType) !== 'number',
    });

    if (description) {
        return (
            <Tippy placement={tooltipPlacement} content={(
                <span>{description}</span>
            )}>
                <div {...outerElement}>
                    <FontAwesomeIcon icon={calculateIcon()} className={iconClassName} {...props} />
                </div>
            </Tippy>
        );
    }

    return (
        <div {...outerElement}>
            <FontAwesomeIcon icon={calculateIcon()} className={iconClassName} />
        </div>
    );
};